import { API_BASE_URL } from "src/config/api";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Buffer } from 'buffer';
import { Dialog, IconButton, Box, Button, Stack, Grid, Typography, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Iframe from 'react-iframe';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';

import TimeIntervalDropdown from '../TimeIntervalDropDown';
// import CustomTimeRangePopup from '../CustomTimeRangePopup';

const iframDivStyle = {
  marginLeft: '7px',
};
export default function Windows() {
  const navigate = useNavigate();
  const [isLoadingCount, setIsLoadingCount] = useState(19); //  19 is the total number of iframe
  const token = localStorage.getItem('token');
  const currentTimeInMilliseconds = new Date().getTime();
  const [startTime, setStartTime] = useState(currentTimeInMilliseconds - 5 * 60 * 1000);
  const [endTime, setEndTime] = useState(currentTimeInMilliseconds);
  // const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [grafanaToken, setGrafanaToken] = useState();

  const [fullscreenSrc, setFullscreenSrc] = useState('');
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [hoveredPanel, setHoveredPanel] = useState(null);

  const { encodedParams } = useParams();
  let decodedParams = {};

  try {
    const decoded = JSON.parse(Buffer.from(encodedParams, 'base64').toString('utf-8'));
    decodedParams = decoded;
  } catch (e) {
    console.error('Invalid URL parameters');
  }

  const { dashboardName, userName, ipAddress, typeOfOS, portAddress, dataRetentionDays } = decodedParams;
  useEffect(() => {

    if (typeOfOS !== 'windows') {
      navigate(`/dashboard/monitors`);
      return
    }
    fetchGrafanaToken();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, endTime, typeOfOS]);

  const fetchGrafanaToken = async () => {
    try {
      const cleanToken = token.replace(/"/g, '');
      const config = {
        headers: {
          Authorization: `Bearer ${cleanToken}`,
        },
      };
      const response = await axios.get(`${API_BASE_URL}/createGrafanaToken`, config);
      if (response.data.success === true) {
        setGrafanaToken(response.data.token);
      }
    } catch (error) {
      console.error('Error fetching token', error);
    }
  };
  const handleRefreshClick = () => {
    fetchGrafanaToken();
  };

  const handleIntervalSelect = (selectedInterval) => {
    setIsLoadingCount(19);
    const intervalInMilliseconds = selectedInterval * 60 * 1000;
    setStartTime(currentTimeInMilliseconds - intervalInMilliseconds);
    setEndTime(currentTimeInMilliseconds);
  };
  // const handleShowCustomPopup = () => {
  //   setShowCustomPopup(true);
  // };

  const handleApplyButtonClick = (newStartTime, newEndTime) => {
    setIsLoadingCount(19);
    setStartTime(newStartTime);
    setEndTime(newEndTime);
  };

  const handleIframeLoad = () => {
    setIsLoadingCount((prevCount) => prevCount - 1);
  };

  const handleOpenFullscreen = (src) => {
    setFullscreenSrc(src);
    setIsFullscreenOpen(true);
  };

  const handleCloseFullscreen = () => {
    setIsFullscreenOpen(false);
    setFullscreenSrc('');
  };


  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h3" gutterBottom>
          Node Metrics
        </Typography>
        <Stack direction="row" spacing={2}>
          <TimeIntervalDropdown onSelect={handleIntervalSelect} dataRetentionDays={dataRetentionDays} />
          {/* <Button variant="outlined"  color="primary" onClick={handleShowCustomPopup}>
            Select Custom Time
          </Button> */}
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            onClick={handleRefreshClick}
            color='primary'
            sx={{
              textTransform: 'none',
              borderRadius: '8px',
              paddingX: 2,
              paddingY: 0.8,
              minWidth: '100px',

            }}
          >
            Refresh
          </Button>
          {/* {showCustomPopup && (
            <CustomTimeRangePopup
              open={showCustomPopup}
              onClose={() => {
                setShowCustomPopup(false);
              }}
              onApply={handleApplyButtonClick}
            />
          )} */}
        </Stack>
      </Stack>

      {isLoadingCount > 0 && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '110%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        >
          <CircularProgress color="primary" />
        </div>
      )}

      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={2}>
          {/* Row 1 */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box sx={iframDivStyle}>
                      <Iframe
                        title={`graph-33}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=33&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                        width="100%"
                        height={80}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box sx={iframDivStyle}>
                      <Iframe
                        title={`graph-37}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=37&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                        width="100%"
                        height={90}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box sx={iframDivStyle}>


                      <Iframe
                        title={`graph-35}`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=35&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                        width="100%"
                        height={90}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box sx={iframDivStyle}>
                  <Iframe
                    title={`graph-19}`}
                    src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=19&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                    width="100%"
                    height={200}
                    frameBorder={1}
                    onLoad={handleIframeLoad}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box sx={iframDivStyle}>


                  <Iframe
                    title={`graph-21}`}
                    src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=21&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                    width="100%"
                    height={200}
                    frameBorder={1}
                    onLoad={handleIframeLoad}
                  />
                </Box>
              </Grid>
              {/* <Grid item xs={12} md={3}>
                    <Box sx={iframDivStyle}>
                      <Iframe
                        title={`graph-19`}
                        src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=56&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                        width="100%"
                        height={200}
                        frameBorder={1}
                        onLoad={handleIframeLoad}
                      />
                    </Box>
                  </Grid> */}
              <Grid item xs={12} md={3}>
                <Box sx={iframDivStyle}>
                  <Iframe
                    title={`graph-57}`}
                    src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=57&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                    width="100%"
                    height={200}
                    frameBorder={1}
                    onLoad={handleIframeLoad}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(23)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-23}`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=23&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 23 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=23&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(7)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-7`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=7&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 7 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=7&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(27)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-27`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=27&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 27 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=27&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} >
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(25)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-25`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=25&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 25 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=25&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(14)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-14`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=14&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 14 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=14&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(15)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-15`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=15&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 15 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=15&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>


                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} >
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(11)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-11`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=11&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 11 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=11&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(8)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-8`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=8&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 8 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=8&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(9)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-9`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=9&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 9 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=9&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>


                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} >
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(29)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-29`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=29&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 29 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=29&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(10)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-10`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=10&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 10 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=10&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>


                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(12)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-12`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=12&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 12 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=12&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box sx={iframDivStyle}>

                  <Box
                    position="relative"
                    onMouseEnter={() => setHoveredPanel(13)}
                    onMouseLeave={() => setHoveredPanel(null)}
                  >
                    <Iframe
                      title={`graph-13`}
                      src={`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=13&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`}
                      width="100%"
                      height={200}
                      frameBorder={1}
                      onLoad={handleIframeLoad}
                    />
                    {hoveredPanel === 13 && (
                      <IconButton
                        onClick={() => handleOpenFullscreen(`${process.env.REACT_APP_API_GRAFANA_URL}/d-solo/Kdh0OoSGz/windows-server-metrics-dashboard?orgId=1&from=${startTime}&to=${endTime}&timezone=browser&var-job=${userName}&var-hostname=${ipAddress}&var-instance=${ipAddress}%3A${portAddress}&var-show_hostname=WINDOWS-SNUVT66&theme=light&panelId=13&__feature.dashboardSceneSolo&auth_token=${grafanaToken}`)}
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: 'rgba(130, 130, 130, 0.6)',
                          color: 'white',
                          zIndex: 2,
                          '&:hover': {
                            backgroundColor: 'rgba(164, 164, 164, 0.8)',
                          },
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    )}
                  </Box>

                </Box>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Box>




      <Dialog
        open={isFullscreenOpen}
        onClose={handleCloseFullscreen}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '80vw',
            height: '80vh',
            maxWidth: 'none',
            position: 'relative', // needed for absolute children
            backgroundColor: 'black', // optional
          },
        }}
      >
        <IconButton
          onClick={handleCloseFullscreen}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'white',
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Iframe
          src={fullscreenSrc}
          width="100%"
          height="100%"
          frameBorder={0}
          style={{ border: 'none' }}
        />
      </Dialog>
    </>
  );
}
